import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../theme/Component/BasicButton";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectStateConst } from "../../Talentohumano/GestionTH/PaymentAccount/SelectStateConst";
import { _AddPayment, _PaymentTurn } from "../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../theme/Component/usePaginator";
import { PaymentAccountItem } from "../../Talentohumano/GestionTH/PaymentAccount/PaymentAccountItem";
import { PaymentAccountItemByTurn } from "../../Talentohumano/GestionTH/PaymentAccount/PaymentAccountItemByTurn";
import { DocumentStorageEditor } from "../../contabilidad/bodegaDocumentos/DocumentStorageEditor";
import { PrintJson } from "../../theme/Component/PrintJson";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";
import useModal, { MODAL_LG } from "../../theme/Component/hooks/useModal";
import { HandlerInfoProcess } from "../../bpm/config/InfoTramiteComponents/HandlerInfoProcess";



export const PaymentTurn = () => {

    const PaymentTurn = useDataBean(_PaymentTurn);
    const single = Singleton.getInstance();
    const _documentos = useDataBean(_DocumentFactory);
    const AddPayment = useDataBean(_AddPayment);
    const [lista, setLista] = useState<any>([]);
    const [docs, setDocs] = useState<any>([]);
    const [response, setResponse] = useState<any>([]);
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [month, setmonth] = useState<number>(null)
    const [idAccount, setidAccount] = useState<number>(null)
    const [state, setstate] = useState<number>(null)
    const paginador = usePaginator();
    const [modalverdoc, setModalverdoc] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [add, setadd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalbyturn, setModalbyturn] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const modalIMP = useModal("Historial de Flujo de Aprobación", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [paginador.page])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        PaymentTurn.instance.getPaymentTurnCatalog(year, month, idAccount, state, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    // setLista(resp.List)
                    let newList = resp.List;
                    if (newList.length > 0) {
                        newList.map((item) => {
                            item.DataBeanProperties.Doc = ((item.DataBeanProperties.DocumentMnemonic ?? "") + " - " + (item.DataBeanProperties.DocumentConsecutive ?? ""))
                        })
                    }
                    setLista(newList)
                }
            }
        )
    }
    const verDocumentos = () => {

        if (PaymentTurn.bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(PaymentTurn.bean.IDDocument, null, PaymentTurn.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const addPaymentAccountToPaymentTurn = () => {

        AddPayment.instance.addPaymentAccountToPaymentTurn(AddPayment.bean.Year, AddPayment.bean.IDDocument, AddPayment.bean.DocumentDate, AddPayment.bean.Code, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Enturnado');
                    setResponse(resp);
                    getLista();
                    setadd({ ...add, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        PaymentTurn.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        PaymentTurn.deleteItemVoid(PaymentTurn.bean.IDPaymentTurn).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        PaymentTurn.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'Turno', property: 'IDPaymentTurn', visible: true },
        { title: 'Vigencia', property: 'TurnYear', visible: true },
        { title: 'Código Turno', property: 'TurnCode', visible: true },
        { title: 'Fecha Turno', property: 'Since', visible: true },
        { title: 'ID Cuenta por Pagar', property: 'IDPaymentAccount', visible: true },
        { title: 'Fecha Cuenta por Pagar', property: 'PaymentAccountDate', visible: true },
        { title: 'Beneficiario', property: 'AccountName', visible: true },
        { title: 'Estado Cuenta por Pagar', property: 'StateName', visible: true },
        { title: 'Documento Contable', property: 'Doc', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Items de la Cuenta por Pagar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalbyturn({ ...modalbyturn, "view": true }) } },
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },
            { titulo: 'Ver Historial de Flujo de Aprobación', icono: 'ri-file-history-line', visible: PaymentTurn.bean.IDProcedureImp, evento: () => { modalIMP.open() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const veradd = () => {

        setadd({ ...add, "view": true });
    }


    return (
        <BasicPage titulo="Turnos de Pago de Cuentas por Pagar">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-4">
                    <MonthConstantsEditor idSelect={month} onChange={(e) => { setmonth(e) }} label="Mes" name="" />
                </div>
                <div className="col-md-4">
                    <AccountEditor label="Tercero" idAccount={idAccount} onChange={(e) => { setidAccount(e.IDAccount) }}></AccountEditor>
                </div>
                <div className="col-md-4">
                    <SelectStateConst label='Estado de la Operación' idSelector={state} onChange={(e) => { setstate(parseInt(e)) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Consultar
                    </BasicButton>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={veradd}>
                        Enturnar Cuenta por Pagar
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={PaymentTurn.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} records={paginador}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={PaymentTurn.bean.Code} onChange={PaymentTurn.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={PaymentTurn.bean.Name} onChange={PaymentTurn.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalbyturn} updateModal={setModalbyturn}>
                        <div className="row">
                            <PaymentAccountItemByTurn IDPaymentAccount={PaymentTurn.bean.IDPaymentAccount} />
                        </div>
                    </Modal>
                    <Modal modal={add} updateModal={setadd} eventModal={addPaymentAccountToPaymentTurn}>
                        <div className="row">
                            <div className="col-md-12">
                                <YearSelector value={AddPayment.bean.Year} tittle="Año" onChange={(e) => { AddPayment.setBean({ ...AddPayment.bean, "Year": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <DocumentStorageEditor label='Documento' onChange={(e) => { AddPayment.setBean({ ...AddPayment.bean, "IDDocument": e.IDDocument, "DocumentDate": e.DocumentDate }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Código</label>
                                <input type="text" className="form-control" name="Code" value={AddPayment.bean.Code} onChange={AddPayment.handleChange} />
                            </div>
                            {/* <div className="col-md-12">
                            <PrintJson json={response}/>
                        </div> */}
                        </div>
                    </Modal>
                    <div className="col-md-12">
                        <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docs}
                                        IDDocument={PaymentTurn.bean.IDDocument}
                                        Since={PaymentTurn.bean.DocumentDate}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {PaymentTurn.bean.Name}</strong>
                    </ModalConfirm>

                    <Modal modal={modalIMP.modal} updateModal={modalIMP.setModal} >
                        <HandlerInfoProcess _ProcedureIMPID={PaymentTurn.bean.IDProcedureImp} />
                    </Modal>

                </div>

            </div>
        </BasicPage>
    )
}